import { html, type TemplateResult } from '@design.estate/dees-element';
import type { DeesChartArea } from './component.js';
import '../../00group-utility/dees-icon/dees-icon.js';

export const renderChartArea = (component: DeesChartArea): TemplateResult => {
      return html`
        <dees-tile>
          <div slot="header" class="chartHeader">
            <span class="chartLabel">${component.label}</span>
            <button class="expandBtn" @click=${() => component.toggleFullPage()} title="${component.isFullPage ? 'Exit full page' : 'Full page'}">
              <dees-icon .icon=${component.isFullPage ? 'lucide:Minimize2' : 'lucide:Maximize2'} .iconSize=${14}></dees-icon>
            </button>
          </div>
          <div class="chartContainer">
            <div class="rangeSelectionOverlay" aria-hidden="true"></div>
          </div>
          ${component.seriesStats.length > 0 && !component.hideLegend ? html`
            <div slot="footer" class="statsBar">
              ${component.seriesStats.map(s => html`
                <div class="statsSeries">
                  <span class="statsColor" style="background:${s.color}"></span>
                  <span class="statsName">${s.name}</span>
                  ${component.legendStats
                    .filter(key => key === 'latest' || key === 'min' || key === 'max' || key === 'avg')
                    .map(key => html`
                      <span class="statsItem">${key} <strong>${component.yAxisFormatter(s[key])}</strong></span>
                    `)}
                </div>
              `)}
            </div>
          ` : ''}
        </dees-tile>
      `;
};
